import { FC } from "react";

export enum RouteType {
    Edit = "/:form_id/editor",
    Design = "/:form_id/design",
    Logic = "/:form_id/logic",
    Validation = "/:form_id/validation",
    Integration = "/:form_id/integration",
    Payment = "/:form_id/payment",
    Preview = "/:form_id/preview",
    Promocode = "/:form_id/payment/promocode",
    Receipt = "/:form_id/payment/receipt",
    PayPal = "/:form_id/payment/paypal",
    Stripe = "/:form_id/payment/stripe",
    Square = "/:form_id/payment/square"
}

export enum RouteNames {
    Edit = "editor",
    Design = "design",
    Logic = "logic",
    Validation = "validation",
    Integration = "integration",
    Payment = "payment",
    Preview = "preview",
}

export interface IRoute {
    path: RouteType;
    element: FC<any>;
    meta: { caseSensetive: boolean };
    children?: IRoute[]
}
